import { useUserStoreOutside } from '@/store/modules/user'
import { appVersion, getEnv } from '@/utils'
import { baseURL } from './constant'

/**
 * 接口错误捕获
 */
export function apiDebugger(instanse: any) {
  console.groupCollapsed(`[🌐 API ${instanse?.config?.method}]`, `${instanse?.config?.baseURL}${instanse?.config?.url}`)
  console.log(`req`, instanse?.config)
  console.log(`res`, instanse)
  console.groupEnd()
}

/**
 * 生成token
 */
export function genToken() {
  const userStore = useUserStoreOutside()
  const Authorization = userStore.authorization
  if (Authorization) {
    // const originUser = userStore.originId
    const res = {
      Authorization
    }
    // if (originUser) res['x-origin-user'] = originUser
    return res
  } else {
    return {}
  }
}

/**
 * 生成应用基础头
 */
export function genAppConfig() {
  return {
    appkey: getEnv('VITE_BD_APP_KEY'),
    'x-app-version': appVersion
  }
}

/**
 * 生成应用头
 */
export function genHeaders() {
  return {
    ...genAppConfig(),
    ...genToken()
  }
}

export const genApiUrl = (path: string, host = baseURL) => {
  return host + path
}
